import React from 'react';

const BarcodeTrackingPage = ({
  instruments = [],
  instrumentTags = [],
  getTrackedInstruments: propGetTrackedInstruments
}) => {
  const getTrackedInstruments = () => {
    if (typeof propGetTrackedInstruments === 'function') {
      return propGetTrackedInstruments();
    }
    const tracked = (instruments || []).filter(
      i => i.is_active && (i.status === 'sterile-pending' || i.status === 'sterile-ready' || i.status === 'in-use' || i.status === 'recalled')
    );
    return tracked.reduce((acc, curr) => {
      if (!acc[curr.item_name]) acc[curr.item_name] = [];
      acc[curr.item_name].push(curr);
      return acc;
    }, {});
  };

  const trackedInstruments = getTrackedInstruments();

  return (
    <div style={{ background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
      <h2>🔍 ตรวจสอบสถานะบาร์โค้ดรายชิ้น</h2>
      <p style={{ color: '#666', fontSize: '0.95em', marginBottom: '20px' }}>* แสดงข้อมูลพัสดุที่กำลังดำเนินการ (นึ่ง, พร้อมจ่าย, ใช้งานอยู่ในคลินิก)</p>

      {Object.keys(trackedInstruments).length === 0 ? (
        <div style={{ textAlign: 'center', padding: '30px', color: '#999', background: '#f9f9f9', borderRadius: '8px' }}>ไม่มีรายการพัสดุที่กำลังดำเนินการ</div>
      ) : (
        Object.keys(trackedInstruments).map(itemName => (
          <div key={itemName} style={{ marginBottom: '20px', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ background: '#2c3e50', color: '#fff', padding: '10px 15px', fontWeight: 'bold', fontSize: '1.1em' }}>
              📦 {itemName} <span style={{ background: '#34495e', padding: '3px 8px', borderRadius: '12px', fontSize: '0.8em', marginLeft: '10px' }}>{trackedInstruments[itemName].length} ชิ้น</span>
            </div>

            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.95em' }}>
                <tbody>
                  {trackedInstruments[itemName].map(instr => {
                    let bgColor = '#fff';
                    let statusUI = '';
                    if (instr.status === 'sterile-ready') {
                      bgColor = '#f1f8e9';
                      statusUI = <span style={{ color: '#27ae60', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>✅ พร้อมจ่าย (Sterile แล้ว)</span>;
                    } else if (instr.status === 'sterile-pending') {
                      bgColor = '#fff3e0';
                      statusUI = <span style={{ color: '#d35400', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>⏳ อยู่ระหว่างขั้นตอนแพ็คและส่งนึ่ง (Sterile Pending)</span>;
                    } else if (instr.status === 'in-use') {
                      bgColor = '#e3f2fd';
                      const locName = (instr.location || '').replace('- ', '').trim();
                      statusUI = <span style={{ color: '#0288d1', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>🏥 ถูกส่งไปที่: {locName}</span>;
                    } else if (instr.status === 'recalled') {
                      bgColor = '#ffebee';
                      statusUI = <span style={{ color: '#c62828', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>⚠️ ถูกอายัด (Recall) - ต้องส่งคืนห้องล้างเท่านั้น</span>;
                    }

                    const tag = instrumentTags.find(t => String(t.id) === String(instr.details?.tag_id));

                    return (
                      <tr key={instr.id} style={{ borderBottom: '1px solid #eee', background: bgColor }}>
                        <td style={{ padding: '12px', textAlign: 'center', width: '220px', fontWeight: 'bold', letterSpacing: '1px' }}>{instr.unique_barcode}</td>
                        <td style={{ padding: '12px' }}>
                          {statusUI}
                          {tag && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                              {tag.image_url && (
                                <img src={tag.image_url} alt={tag.name} style={{ width: '30px', height: '30px', borderRadius: '4px', objectFit: 'cover', border: '1px solid #ddd' }} />
                              )}
                              <span style={{ fontSize: '0.85em', background: '#eceff1', padding: '2px 6px', borderRadius: '4px', color: '#37474f', fontWeight: 'bold' }}>🔖 Tag: {tag.name}</span>
                            </div>
                          )}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'right' }}>
                          <button onClick={() => {
                            navigator.clipboard.writeText(instr.unique_barcode);
                            alert(`📋 คัดลอกรหัส ${instr.unique_barcode} เรียบร้อยแล้ว`);
                          }} style={{ background: '#fff', border: '1px solid #bdc3c7', color: '#333', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                            📋 คัดลอก
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default BarcodeTrackingPage;
